$(function() {
  $('body').on('click', '.button-modal-collapse', function() {
    $(this).toggleClass('button-modal-collapse--collapsed')
    $(this)
      .closest('.planboard__package-selector')
      .toggleClass('planboard__package-selector--collapsed')
      .find('.modal-collapsible-content')
      .toggleClass('modal-collapsible-content--hidden')
  })
})
